module.exports = __webpack_public_path__ + "static/scale-model-of-american-victory-ship-&-museum-in-tampa-florida-c5bf404a64869643480fd7c67f3c8023.png";